import React from 'react'
import { useTheme } from '@emotion/react'
import slug from 'slug'
import Stack from 'react-bootstrap/Stack'
import useGetSiteMetadata from '../hooks/useGetSiteMetadata'

import { ReactComponent as Facebook } from '../images/facebook-icon-white.svg'
import { ReactComponent as Twitter } from '../images/twitter-x-icon-white.svg'
import { ReactComponent as Instagram } from '../images/instagram-icon-white.svg'
import { ReactComponent as Youtube } from '../images/youtube-icon-white.svg'
import { ReactComponent as Soundcloud } from '../images/soundcloud-icon-white.svg'
import { ReactComponent as TikTok } from '../images/tiktok-icon-white.svg'

export default function Socials({ keyHelper, className, style, variant }) {
    const { socials } = useGetSiteMetadata()
    const theme = useTheme()

    const size = 24
    const props = {
        width: size,
        height: size,
    }

    const icons = {
        "Facebook": <Facebook {...props} />,
        "Twitter": <Twitter {...props} />,
        "Instagram": <Instagram {...props} />,
        "Youtube": <Youtube {...props} />,
        "Soundcloud": <Soundcloud {...props} />,
        "TikTok": <TikTok {...props} />,
    }

    return (
        <Stack
            direction='horizontal'
            gap={4}
            className={className}
            style={style}
            css={{
                '& path': {
                    fill: variant ? theme.colors[variant] : 'white'
                }
            }}
        >
            {socials.map(({ name, url }) => {
                const strings = [(keyHelper || 'socials'), name, (variant || 'white')]
                const key = slug(strings.join(' '))
                return (
                    <a
                        key={key}
                        href={url}
                        target='_blank'
                        rel='noreferrer'
                    >
                        {icons[name]}
                    </a>
                )
            })}
        </Stack>
    )
}
